import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import MapPage from '@/organizations/_default/map'

import AreaFilter from './components/AreaFilter.vue'
import functions from './utils/functions.ts'

export default defineComponent({
  extends: MapPage,
  components: {
    AreaFilter
  },
  setup(props, context) {
    const page = MapPage.setup(props, context)
    const store = useStore()

    store.dispatch('setOrganizationActions', functions)

    return page
  }
})
